import { render, staticRenderFns } from "./ConsumerHabits.vue?vue&type=template&id=561ff062"
import script from "./ConsumerHabits.vue?vue&type=script&lang=js"
export * from "./ConsumerHabits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports